function getEnv() {
  const hostname = globalThis.location?.hostname ?? "localhost";

  if (hostname === "localhost") {
    return "localhost";
  }

  if (hostname.startsWith("stage.")) {
    return "stage";
  }

  if (hostname.startsWith("dev.")) {
    return "dev";
  }

  return "production";
}

const configByEnv = {
  localhost: {
    apiWs: "ws://localhost:8080",
    apiUrl: "http://localhost:8080",
  },
  dev: {
    apiWs: "wss://dev.labs1503.api.topmonks.com",
    apiUrl: "https://dev.labs1503.api.topmonks.com",
  },
  stage: {
    apiWs: "wss://stage.labs1503.api.topmonks.com",
    apiUrl: "https://stage.labs1503.api.topmonks.com",
  },
  production: {
    apiWs: "wss://labs1503.api.topmonks.com",
    apiUrl: "https://labs1503.api.topmonks.com",
  },
};

const env = getEnv();

export const config = {
  env: env,
  locale: { time: "cs-CZ" },
  ...configByEnv[env],
};
